<template>
<footer style="z-index:9999">
  <div>
    <img src="../assets/img/footer.png" alt="">
  </div>
  <div class="text">
    <div class="left">
      <p>
          <router-link to="/index" tag="span" >首页</router-link>
          <router-link to="/product" tag="span" exact>产品介绍</router-link>
      </p>
      <p>
          <router-link to="/flow" tag="span" exact>自主流量</router-link>
          <router-link to="/case" tag="span" exact>行业案例</router-link>
          <router-link to="/we" tag="span" exact>关于我们</router-link>
      </p>
    </div>
    <div class="right"> 
      <p>ICP证号：京B2-20170526<a href="https://beian.miit.gov.cn/" target="_blank">&emsp;京ICP备17007689号</a></p>
      <p>&copy;&nbsp;北京知行车谷科技有限公司</p>
      <a href="https://weibo.com/acegear" target="_blank">
      <div class="weibo dain" ></div>
      </a> 
      
      <el-tooltip  placement="top">
        <div class="weixin dain" ></div>
        <div slot="content" style="z-index:9999">
          <img src="../assets/img/erweima.jpeg" style="width:100px"/>
        </div>
      </el-tooltip>
      <el-tooltip  placement="top" content="信箱 info@acegear.com">
        <div class="e-mail dain" ></div> 
      </el-tooltip>
      
      
    </div>
    
  </div>
</footer>
</template>

<script>
export default {
  data() {
    return {
      type: "a",
    };
  },
  methods: {
    show() {
      this.type = "a";
    },
  },
  showwb() {
    this.type = "b";
  },
  showe() {
    this.type = "c";
  },
};
</script>


<style lang="scss" scoped>
footer {
  width: 100%;
  height: 2.1rem;
  color: #666666;
  overflow: hidden;
  .text {
    height: 0.66rem;
    width: 12rem;
    position: relative;
    top: -1.33rem;
    margin: 0 auto;
  }
  .left {
    width: 3rem;
    float: left;
    font-size: 0.17rem;
    margin-top: 0.2rem;
    span {
      display: inline-block;
      height: 0.4rem;
      width: 0.9rem;
      cursor: pointer;
    }
  }
  .right {
    width: 5rem;
    text-align: right;
    float: right;
    font-size: 0.17rem;
    margin-top: 0.26rem;
    line-height: 0.32rem;
    a:hover {
      color: #666666;
      text-decoration: none;
    }
    .dain {
      height: 0.48rem;
      width: 0.48rem;
      position: relative;
      border-radius: 50%;
    }
    .weibo {
      top: -1.7rem;
      right: -3.34rem;
    }
    .weixin {
      top: -2.17rem;
      right: -3.9rem;
    }
    .e-mail {
      top: -2.64rem;
      right: -4.46rem;
    }
    a{color: #666666;}
    .weibo-show {
      width: 1.8rem;
      height: 1.8rem;
      position: relative;
      top: -3.4rem;
      right: 1.8rem;
      z-index: 9999;
      a:hover {
        color: #666666;
      }
    }
  }
}
</style>
